import { useEffect, useState } from 'react'
import { getBaseApi, getLocaleFromUrlOrQuery, getUrlParts, isPreviewUrl } from '../Utils/common'
import { ProductListSections, TravelSearchConfigResponse } from '../../api/travel-search-config'
import { fetcher } from '../Utils/fetcher'

const baseApi = getBaseApi()

export function useTravelSearchConfig(): UseTravelSearchConfigResult {
  const [configData, setConfigData] = useState<TravelSearchConfigResponse | null>(null)
  const [isLoading, setIsLoading] = useState(true)

  const previewId = isPreviewUrl()
  const parts = getUrlParts()
  const locale = getLocaleFromUrlOrQuery()
  let urlSlug = parts.slice(1).join('/') || '/'
  let isNextApplication = false

  // Handle localhost override for dev
  if (window.location.hostname === 'localhost' && window.location.pathname.endsWith('/travel')) {
    const parts = window.location.pathname.split('/')
    urlSlug = parts[2]
    isNextApplication = true
  } else {
    isNextApplication = document.getElementById('__next') !== null
  }

  if (window.location.hostname === 'localhost') {
    isNextApplication = true
  }

  const previewIdString = previewId ? `&previewId=${previewId}` : ''
  const url = `${baseApi}/travel-search-config?locale=${locale}&urlSlug=${urlSlug}${previewIdString}&isNextApplication=${isNextApplication}`

  useEffect(() => {
    const controller = new AbortController()
    setIsLoading(true)

    fetcher<TravelSearchConfigResponse>(url, {
      signal: controller.signal,
      cache: 'default',
    })
      .then((res) => {
        setConfigData(res)
      })
      .catch((err) => {
        if (!controller.signal.aborted) {
          console.error('Failed to fetch travel search config:', err)
        }
      })
      .finally(() => {
        if (!controller.signal.aborted) {
          setIsLoading(false)
        }
      })

    return () => controller.abort()
  }, [url])

  return {
    isLoading,
    isMultiOffer: configData?.isMultiOffer ?? false,
    availableMinibooks: configData?.availableMinibooks ?? [],
    optionalOfferTitle: configData?.optionalOfferTitle,
    route: configData?.route,
  }
}

export interface UseTravelSearchConfigResult {
  isLoading: boolean
  isMultiOffer: boolean
  availableMinibooks: ProductListSections[] | string
  optionalOfferTitle?: string
  route?: string
}
